$shm_confirm_delete $mol_pick
	align \center
	title \Удалить
	question \Удалить?
	confirm_title \Да
	cancel_title \Нет
	confirmed? null
	trigger_content /
		<= Trigger_icon $mol_icon_trash_can
		<= title
	bubble_content /
		<= Content $mol_view
			sub /
				<= Question $mol_text
					text <= question
				<= Confirm $mol_button_minor
					title <= confirm_title
					click? <=> confirm_click? null
				<= Cancel $mol_button_minor
					title <= cancel_title
					click? <=> cancel_click? null
